import React from 'react';
import { Icon } from './Icon.js';
export const IconPhoneOffice = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 20V23", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 3H21V19H13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 3L9 20L3 20L3 3L9 3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M17 7L17 11L13 11L13 7L17 7Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M17 15.01V15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPhoneOffice.js.map